import { Field, Form, Formik } from "formik"
import React from "react"
import Row from "../Row"
import { IFormGroupProduct } from "./interface"
import { Column, Legend } from "./style"
import * as Yup from "yup";
import { useSelector } from "react-redux"
import Button from "../Button"
import Input from "../Input"
import { ToastContainer } from "react-toastify";
import { toastCreate } from "../../utils/notifications/toast"
import { ContainerInput } from "../../views/card/cardPaymentLink/styles"
import MsgErrorInput from "../MsgErrorInput"
import { addGroupProducts } from "../../hooks/addGroupProducts"

const FormGroupProduct = ({
    refresh,
    setRefresh
}: IFormGroupProduct
): React.ReactElement  => {
    const login = useSelector((state: {login: any}) => state.login);
    const formValidationWithYup = Yup.object().shape({
        name: Yup.string().required("*Preenchimento obrigatório"),
        description: Yup.string().required("*Preenchimento obrigatório"),
    })

    return (
        <Formik
            initialValues={{
                name: "",
                description: "",
            }}
            validationSchema={formValidationWithYup}
            onSubmit={(values) => {
                addGroupProducts(
                    values,
                    login.user.branchs.sellerOwnerPayId,
                    refresh,
                    setRefresh
                )
            }}
        >
            {({ errors, dirty, isValid, touched }) => (
                <Form>
            <ToastContainer autoClose={2000} />

                    <Row>
                        <Column>
                        <ContainerInput>
                            <Field 
                                id="name" 
                                name="name" 
                                className="inputCustom" 
                                placeholder="Nome do grupo"
                                isError={touched.name && errors.name}
                                as={Input}
                            />
                            <MsgErrorInput>
                                {
                                    touched.name && errors.name
                                    ? errors.name
                                    : null
                                }
                            </MsgErrorInput>
                        </ContainerInput>
                            <ContainerInput>
                                <Field 
                                    id="description" 
                                    name="description" 
                                    className="inputCustom" 
                                    placeholder="Descrição do grupo" 
                                    isError={touched.description && errors.description}
                                    as={Input}
                                />
                            </ContainerInput>
                        </Column>
                    </Row>
                    <Row>
                        <Column>
                            <Button 
                                id="btn-submit"
                                disabled={ !(dirty && isValid)}
                                onClick={() => {
                                    toastCreate("createGroup","info", 1500, "Processando...")
                                }}
                                type="submit">
                                    Criar grupo
                            </Button>
                        </Column>
                    </Row>
                </Form>
            )}    
        </Formik>
    )
}

export default FormGroupProduct